{
  "battery": "Batería",
  "device": "Dispositivo",
  "depth": "Profundidad",
  "flow": "Fluir",
  "gps": "GPS",
  "hallSwitch": "Interruptor de pasillo",
  "hall_switch": "Interruptor de pasillo",
  "humidity": "Humedad",
  "icm": "Orientación",
  "pressure": "Presión",
  "pressureSwitch": "Interruptor de presión",
  "pressure_switch": "Interruptor de presión",
  "reel": "Carrete",
  "relay": "Relé",
  "temperature": "Temperatura",
  "vfd": "Variador de frecuencia variable",
  "wheel": "Rueda"
}
